// Joins staged composer text and an appended line on a newline — a picked template body or
// attachment URI lands on its own line below whatever is staged.
export const appendMessageLine = (prev: string, text: string): string => `${prev}\n${text}`
